<template>
  <div
    :style="`width: ${enlarge ? '100%' : '270px'};
      position: fixed;
      bottom: 0px;
      right: 0px;
      ${enlarge ? 'left:0px' : null};
      z-index: 9999999999;`"
    class="pointer p4"
    :key="'pointerdisplay' + points.length"
  >
    <div
      :class="` point point-${pointkey} b4 t4`"
      v-for="(point, pointkey) in points"
      :key="pointkey"
    >
      <div
        v-if="point"
        @click="
          point.link &&
          !point.link.includes('http') &&
          $router.path !== point.link
            ? $router.push({ path: point.link })
            : null
        "
        :style="`background: ${
          $store.state.app.style.container || rgba(0, 0, 0, 0.8)
        }; color: ${
          $store.state.app.style.color || rgba(255, 255, 255, 0.8)
        }; border-radius: 4px;`"
        :class="`container p16 column flex ${point.type || 'success'}-border`"
      >
        <div class="flex align-center between">
          <i
            @click="enlarge = !enlarge"
            :class="`fa fa-angle-${enlarge ? 'right' : 'left'} border p4`"
          ></i>
          <itime gran="minute" class="xs-font" :timestamp="+pointkey" />
          <i
            @click="$delete($store.state.pointer, pointkey)"
            class="fa fa-times border p4"
          ></i>
        </div>

        <div
          :class="`flex align-center between ${point.type || 'success'}-text`"
        >
          <b v-if="point.header" class="md-font">{{ point.header }}</b>
        </div>
        <code style="overflow-y: scroll; max-height: 240px" v-if="point.text" class="xs-font v-scroll">{{
          (() => {
            if (typeof point.text === 'object' && point.text !== null) {
              try {
                const seen = new WeakSet();
                const safeStringify = (obj, indent = 2) => {
                  return JSON.stringify(obj, (key, val) => {
                    if (typeof val === 'object' && val !== null) {
                      if (seen.has(val)) {
                        return '[Circular]';
                      }
                      seen.add(val);
                    }
                    if (typeof val === 'function') {
                      return '[Function]';
                    }
                    return val;
                  }, indent);
                };
                return safeStringify(point.text);
              } catch (e) {
                try {
                  return '[Object with circular reference]';
                } catch (e2) {
                  return '[Unable to display]';
                }
              }
            }
            return point.text;
          })()
        }}</code>
        <div
          class="flex xs-font align-center"
          v-if="point.link && point.link.includes('://')"
        >
          URL:
          <a
            class="h-scroll l4"
            style="white-space: nowrap; width: 100%; overflow-x: scroll"
            target="new"
            :href="point.link"
            >{{ point.link }}</a
          ><i @click="$copyText(point.link)" class="l4 fa fa-copy"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pointer",
  data() {
    return {
      enlarge: false,
    };
  },
  computed: {
    points() {
      Object.keys(this.$store.state.pointer).map((x) => {
        this.$store.state.pointer[x] &&
          !this.$store.state.pointer[x].sticky &&
          setTimeout(() => {
            this.$store.commit("set", { keys: ["pointer", x], val: null });
          }, this.$store.state.pointer[x].speed || 3000);
      });
      return this.$store.state.pointer;
    },
  },
};
</script>
